class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      // Ensure the form exists before adding event listener
      if (this.input.form) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      }

      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300)
      );
    }

    if (this.resetButton) {
      this.resetButton.addEventListener('click', () => this.resetSearch());
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return; // Ensure reset button exists

    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();

    // Close predictive search if input is empty
    if (this.input.value.trim() === "") {
      this.closest('predictive-search')?.closeResults(true);
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault(); // Prevent default form behavior

    if (this.shouldResetForm()) {
      this.resetSearch();
    }
  }

  resetSearch() {
    if (!this.input) return;

    this.input.value = '';
    this.input.focus();
    this.toggleResetButton();

    // Clear predictive search results
    this.closest('predictive-search')?.closeResults(true);
  }

  // Utility: Debounce function to optimize search input performance
  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

customElements.define('search-form', SearchForm);
